import { useMemo, useState } from 'react';
import { Button, Tabs } from '@/components/generic';
import { bitcoinChain, useChainStore } from '@package/smart-wallet';

import Changenow from './Changenow';
import QrCode from './QrCode';

export const AddBalance = () => {
  const chainId = useChainStore((state) => state.chainId);
  const typeTasks = useMemo(
    () => [
      {
        id: 1,
        name: 'QR Code',
      },

      {
        id: 2,
        name: 'Bridge',
        hidden: chainId === bitcoinChain.id,
      },
    ],
    [chainId],
  );
  const [type, setType] = useState(typeTasks[0]);
  const [previewChangeNow, setPreviewChangeNow] = useState(false);

  return (
    <>
      {!previewChangeNow && (
        <>
          <div className='text-h6 mb-2 text-t-primary'>
            Add balance to your account
          </div>
          <Tabs items={typeTasks} value={type} setValue={setType} />
        </>
      )}

      {type === typeTasks[0] && <QrCode />}

      {type === typeTasks[1] && (
        <>
          {previewChangeNow ? (
            <>
              <Changenow onBack={() => setPreviewChangeNow(false)} />
            </>
          ) : (
            <>
              <div className='my-4 p-8 bg-shade-01 border-2 border-s-border rounded-2xl max-md:px-4'>
                <div className='mb-3 text-center text-white '>
                  An infinite bridge:
                  {/* <Image className='w-full h-25' src={changenowIMG} alt='' /> */}
                </div>
                <div className='mb-3 text-center text-body-1 text-shade-10'>
                  move any crypto, from any blockchain, straight into your
                  balance.
                </div>
              </div>
              <Button
                onClick={() => setPreviewChangeNow(true)}
                className='w-full '
                type='button'
                isBlack
              >
                Select
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AddBalance;
